let _getAccessTokenSilently: (() => Promise<string>) | null = null;

export function setAuth0TokenGetter(fn: () => Promise<string>) {
  _getAccessTokenSilently = fn;
}

export async function getAccessTokenDirect(): Promise<string> {
  if (!_getAccessTokenSilently) {
    throw new Error("Auth0 token getter not initialized yet");
  }
  return await _getAccessTokenSilently();
}
